import { getEntities } from "../../utils/redux";

export default {
  showModel(state, action) {
    return {
      ...state,
      modelId: action.payload,
    };
  },

  getModelFulfilled(state, action) {
    return {
      ...state,
      entities: getEntities(state, action.payload, "reviews"),
    };
  },

  getReviewsPending(state, action) {
    const { modelId, page } = action.payload;

    return {
      ...state,
      pages: {
        ...state.pages,
        [modelId]: page,
      },
    };
  },

  getReviewsRejected(state, action) {
    const { modelId, pages } = state;

    return {
      ...state,
      pages: {
        ...state.pages,
        [modelId]: pages[modelId] - 1,
      },
    };
  },

  getReviewsFulfilled(state, action) {
    const { modelId } = state;
    const { result } = action.payload;

    return {
      ...state,
      noMores: {
        ...state.noMores,
        [modelId]: result.length < 10,
      },
      entities: getEntities(state, action.payload, "reviews"),
    };
  },
};
